import React, { Component } from "react";

import {
  Chart as ChartJS,
  RadialLinearScale,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

import { PolarArea, Bar } from "react-chartjs-2";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/svg-arrow.css";
import "tippy.js/themes/light.css";

import exportFromJSON from "export-from-json";

//Assets
import Line from "../../Assets/Line.svg";
import PieChart from "../../Assets/pie-chart.svg";
import backBtn from "../../Assets/backBtn.svg";
import documentPdf from "../../Assets/document-pdf.svg";

ChartJS.register(
  RadialLinearScale,
  Legend,
  Tooltip,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement
);

// UserStatistics Component
class UserStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // pages Entire Data = false , Entire Month = true
      activePage: false,
      // pages  Breakfast = 1, Lunch = 2, Dinner = 3
      pageTab: 0,

      // tabs Breakfast = 1, Lunch = 2, Dinner = 3
      activeTab: 1,

      //Todays Entire Data
      PreBloodGlucoseData: 150,
      PostBloodGlucoseData: 150,
      InsulinIntakeData: 150,
      TotalCarbsIntakeData: 150,

      rowData: 0,
    };
  }

  //changing tabs Breakfast = 1, Lunch = 2, Dinner = 3
  changeTab = (tab) => {
    this.setState({
      activeTab: tab,
      PreBloodGlucoseData: 200,
      PostBloodGlucoseData: 200,
      InsulinIntakeData: 200,
      TotalCarbsIntakeData: 200,
    });
  };

  renderTabs(data) {
    return (
      <>
        <div className="UserStatistics_CardHolder">
          <div className="UserStatistics_Card">
            <div>Pre Blood Glucose</div>
            <div>
              {this.state.PreBloodGlucoseData}
              <sub>mmol/L</sub>
            </div>
            <img src={Line} alt="wave" />
          </div>

          <div className="UserStatistics_Card">
            <div>Post Blood Glucose </div>
            <div>
              {this.state.PostBloodGlucoseData}
              <sub>mmol/L</sub>
            </div>
            <img src={Line} alt="wave" />
          </div>

          <div className="UserStatistics_Card">
            <div>Insulin Intake</div>
            <div>
              {this.state.InsulinIntakeData}
              <sub>mmol/L</sub>
            </div>
            <img src={Line} alt="wave" />
          </div>

          <div className="UserStatistics_Card">
            <div>Total Carbs Intake</div>
            <div>
              {this.state.TotalCarbsIntakeData}
              <sub>mmol/L</sub>
            </div>
            <img src={Line} alt="wave" />
          </div>
        </div>

        <div className="UserStatistics_ChartHolder">
          <div className="UserStatistics_Chart">
            <div>Total Carbohydrate Intake</div>
            <div>
              <PolarArea
                type="PolarArea"
                data={data}
                height={280}
                width={280}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            </div>
          </div>
          <div className="UserStatistics_InfoData">
            <div className="UserStatistics_InfoDataTitle">
              <div>Entire Month Data</div>
              <div></div>
            </div>
            <div className="UserStatistics_InfoDataCardHolder">
              <div
                className="UserStatistics_InfoCard"
                card="1"
                onClick={() => {
                  this.changePage(true, 1);
                }}
              >
                <div className="UserStatistics_InfoCardTitle">Monthly</div>
                <div className="UserStatistics_InfoCardInfo">
                  Break Fast Data
                </div>
                <div className="arrow_container">
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                </div>
              </div>

              <div
                className="UserStatistics_InfoCard"
                card="2"
                onClick={() => {
                  this.changePage(true, 2);
                }}
              >
                <div className="UserStatistics_InfoCardTitle">Monthly</div>
                <div className="UserStatistics_InfoCardInfo">
                  Lunch Fast Data
                </div>
                <div className="arrow_container">
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                </div>
              </div>

              <div
                className="UserStatistics_InfoCard"
                card="3"
                onClick={() => {
                  this.changePage(true, 3);
                }}
              >
                <div className="UserStatistics_InfoCardTitle">Monthly</div>
                <div className="UserStatistics_InfoCardInfo">
                  Dinner Fast Data
                </div>
                <div className="arrow_container">
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  EntireDataPage() {
    const CarbohydrateIntakeData = {
      labels: ["Red", "Blue", "Yellow", "Green"],
      datasets: [
        {
          label: "# of Votes",
          data:
            this.state.activeTab === 1
              ? [12, 19, 3, 5]
              : this.state.activeTab === 3
              ? [10, 90, 13, 50]
              : [20, 5, 30, 15],
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
          ],
          borderWidth: 1,
        },
      ],
    };

    return (
      <>
        <div className="UserStatistics_Tab">
          <div
            className={
              this.state.activeTab === 1
                ? "UserStatistics_TabItem TabItem_Active"
                : "UserStatistics_TabItem"
            }
            onClick={() => {
              this.changeTab(1);
            }}
          >
            Breakfast
          </div>
          <div
            className={
              this.state.activeTab === 2
                ? "UserStatistics_TabItem TabItem_Active"
                : "UserStatistics_TabItem"
            }
            onClick={() => {
              this.changeTab(2);
            }}
          >
            Lunch
          </div>
          <div
            className={
              this.state.activeTab === 3
                ? "UserStatistics_TabItem TabItem_Active"
                : "UserStatistics_TabItem"
            }
            onClick={() => {
              this.changeTab(3);
            }}
          >
            Dinner
          </div>
        </div>

        {this.renderTabs(CarbohydrateIntakeData)}
      </>
    );
  }

  downloadExcelSheet = (dataSet) => {
    let date = new Date();

    var dateString =
      ("0" + date.getDate()).slice(-2) +
      "_" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "_" +
      date.getFullYear();

    let data = [];

    const fileName = `${
      this.state.pageTab === 1
        ? "MonthlyBreakfastData"
        : this.state.pageTab === 2
        ? "MonthlyLunchData"
        : this.state.pageTab === 3
        ? "MonthlyDinnerData"
        : null
    }_${dateString}`;

    const exportType = exportFromJSON.types.xls;

    // const tempData = data;
    const tempData = [...Array(20)];

    for (let i = 0; i < tempData.length; i++) {
      let Detail = {};
      Detail["Date"] = `${i + 1} May 2022`;
      Detail["Pre Glucose Level"] = "250mmol/L";
      Detail["Post Glucose Level"] = "350mmol/L";
      Detail["Insulin Intake"] = "20 units";
      Detail["Carbs Intake"] = "200 gms";

      data.push(Detail);
    }
    exportFromJSON({ data, fileName, exportType });
  };

  EntireMonthPage() {
    const data = {
      labels: ["Red", "Blue", "Yellow", "Green"],
      datasets: [
        {
          label: "# of Votes",
          data: [12, 19, 3, 5],
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
          ],
          borderWidth: 1,
        },
      ],
    };

    const data1 = {
      labels: ["one", "two"],
      datasets: [
        {
          label: "Dataset 1",
          data: [20, 20],
          backgroundColor: "rgba(76, 221, 134, 0.6)",
          barThickness: 50,
          borderSkipped: false,
          borderRadius: 100,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 5,
        },
        {
          label: "Dataset 2",
          data: [40, 40],
          backgroundColor: "rgba(114, 131, 246, 0.8)",
          barThickness: 50,
          borderSkipped: false,
          borderRadius: 100,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 5,
        },
      ],
    };

    return (
      <>
        <div className="UserStatistics_DateNExport">
          <input type="date" className="UserStatistics_Date" />
          <div
            className="UserStatistics_Export"
            onClick={() => {
              this.downloadExcelSheet(null);
            }}
          >
            <img src={documentPdf} alt="" />
          </div>
        </div>
        <div className="UserStatistics_TableDate">
          <div className="UserStatistics_Table">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Pre Glucose Level</th>
                  <th>Post Glucose Level</th>
                  <th>Insulin Intake</th>
                  <th>Carbs Intake</th>
                </tr>
              </thead>
              <br />
              <tbody>
                {[...Array(20)].map((data, index) => {
                  return (
                    <tr
                      style={{
                        background:
                          this.state.rowData === index
                            ? " rgba(255, 255, 255, 0.5)"
                            : "",
                      }}
                      onClick={() => {
                        this.setState({
                          rowData: index,
                        });
                      }}
                    >
                      <td>{index + 1} May 2022</td>
                      <td>
                        <div className="UserStatistics_TableData">
                          <Tippy
                            content={<div>Bad</div>}
                            placement="top"
                            theme="dark"
                          >
                            <div
                              style={{ background: "rgba(246, 114, 114, 0.6)" }}
                            ></div>
                          </Tippy>
                          <div>250mmol/L</div>
                        </div>
                      </td>
                      <td>
                        <div className="UserStatistics_TableData">
                          <Tippy
                            content={<div>Good</div>}
                            placement="top"
                            theme="dark"
                          >
                            <div
                              style={{ background: "rgba(114, 246, 159, 0.6)" }}
                            ></div>
                          </Tippy>
                          <div>250mmol/L</div>
                        </div>
                      </td>
                      <td>20 units</td>
                      <td>200 gms</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="UserStatistics_Data">
            <div className="UserStatistics_Graph">
              <div>
                Glucose Readings <span>1 May 2022</span>
              </div>
              <Bar
                type="bar"
                data={data1}
                height={180}
                options={{
                  scales: {
                    x: {
                      barThickness: 0.5,

                      grid: {
                        display: false,
                      },
                    },
                    y: {
                      grid: {
                        display: false,
                      },
                    },
                  },
                  plugins: {
                    title: {
                      display: true,
                      text: "Cryptocurrency prices",
                    },
                    legend: {
                      display: true,
                      position: "bottom",
                    },
                  },
                }}
              />
            </div>
            <div className="UserStatistics_Pie">
              {/* <div>Carbohydrate Ratio</div> */}
              <PolarArea
                type="PolarArea"
                data={data}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  //changing pages Entire Data = 1 , Entire Month = 2 & pages today=0 Breakfast = 1, Lunch = 2, Dinner = 3
  changePage(activePage, pageTab) {
    this.setState({ activePage: activePage, pageTab: pageTab });
  }

  renderPages() {
    if (this.state.activePage) {
      return <>{this.EntireMonthPage()}</>;
    } else {
      return <>{this.EntireDataPage()}</>;
    }
  }

  render() {
    return (
      <div className="UserStatistics">
        <div className="UserStatistics_userName">Hi Aditya Dhamal</div>
        <div className="UserStatistics_Title">
          <div>
            {this.state.pageTab === 1
              ? "Monthly Entire Breakfast Data"
              : this.state.pageTab === 2
              ? "Monthly Entire Lunch Data"
              : this.state.pageTab === 3
              ? "Monthly Entire Dinner Data"
              : "Todays Entire Data"}
          </div>
          <div
            style={{
              width:
                this.state.pageTab === 1
                  ? "73%"
                  : this.state.pageTab === 2
                  ? "76%"
                  : this.state.pageTab === 3
                  ? "75%"
                  : "",
            }}
          ></div>
        </div>

        {this.renderPages()}

        <div
          className="backBtn"
          onClick={() => {
            this.changePage(false, 0);
          }}
          style={{
            zIndex:
              this.state.activePage && this.state.pageTab !== 0 ? "2" : "",
          }}
        >
          <img src={this.state.activePage ? backBtn : PieChart} alt="Setting" />
        </div>
      </div>
    );
  }
}

export default UserStatistics;
